import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const loadGtag = () => {
  if (window.__gtagLoaded) return;
  window.__gtagLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=AW-18450372152";
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", "AW-18450372152");
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(() => {
    try {
      return !localStorage.getItem("rus-consent");
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      if (localStorage.getItem("rus-consent") === "accepted") loadGtag();
    } catch {}
    const reset = () => {
      try {
        localStorage.removeItem("rus-consent");
      } catch {}
      setVisible(true);
    };
    window.addEventListener("reset-cookies", reset);
    return () => window.removeEventListener("reset-cookies", reset);
  }, []);

  const choose = (accepted) => {
    try {
      localStorage.setItem("rus-consent", accepted ? "accepted" : "rejected");
    } catch {}
    if (accepted) loadGtag();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <motion.div
      initial={{ y: 80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-4 bottom-4 z-[70] mx-auto max-w-3xl rounded-2xl border border-cream/15 bg-walnut/95 p-5 text-cream shadow-2xl shadow-black/40 backdrop-blur-xl md:bottom-6"
      data-testid="cookie-banner"
    >
      <p className="font-sans text-xs font-light leading-relaxed text-sand/85 md:text-sm">
        Usiamo cookie tecnici e, solo con il tuo consenso, cookie di Google Ads
        per capire se la pubblicità porta clienti veri. Leggi la{" "}
        <button
          onClick={() => window.dispatchEvent(new Event("open-privacy"))}
          className="underline decoration-honey underline-offset-2 transition-colors hover:text-honey"
          data-testid="cookie-privacy-link"
        >
          privacy policy
        </button>
        .
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button
          onClick={() => choose(true)}
          data-testid="cookie-accept-button"
          className="rounded-full bg-honey px-6 py-2.5 font-sans text-sm font-medium text-ink transition-colors duration-300 hover:bg-cream"
        >
          Accetta
        </button>
        <button
          onClick={() => choose(false)}
          data-testid="cookie-reject-button"
          className="rounded-full border border-cream/25 px-6 py-2.5 font-sans text-sm font-light text-sand transition-colors duration-300 hover:border-honey hover:text-honey"
        >
          Rifiuta
        </button>
      </div>
    </motion.div>
  );
};

export default CookieBanner;
